<script>
  import Fa from 'svelte-fa';
  import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

  export let value;
  export let href = "";
</script>

{#if href && href.includes(".pdf")}<Fa icon={faFilePdf} color="red" />{/if}
{#if href}
  <a {href} target="_blank">{value}</a>
{:else}
  {value}
{/if}
